"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfReferralsControllerRedeemV1200Response = instanceOfReferralsControllerRedeemV1200Response;
exports.ReferralsControllerRedeemV1200ResponseFromJSON = ReferralsControllerRedeemV1200ResponseFromJSON;
exports.ReferralsControllerRedeemV1200ResponseFromJSONTyped = ReferralsControllerRedeemV1200ResponseFromJSONTyped;
exports.ReferralsControllerRedeemV1200ResponseToJSON = ReferralsControllerRedeemV1200ResponseToJSON;
exports.ReferralsControllerRedeemV1200ResponseToJSONTyped = ReferralsControllerRedeemV1200ResponseToJSONTyped;
var RedeemResultDto_1 = require("./RedeemResultDto");
/**
 * Check if a given object implements the ReferralsControllerRedeemV1200Response interface.
 */
function instanceOfReferralsControllerRedeemV1200Response(value) {
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('message' in value) || value['message'] === undefined)
        return false;
    return true;
}
function ReferralsControllerRedeemV1200ResponseFromJSON(json) {
    return ReferralsControllerRedeemV1200ResponseFromJSONTyped(json, false);
}
function ReferralsControllerRedeemV1200ResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'statusCode': json['statusCode'] == null ? undefined : json['statusCode'],
        'status': json['status'],
        'message': json['message'],
        'data': json['data'] == null ? undefined : (0, RedeemResultDto_1.RedeemResultDtoFromJSON)(json['data']),
        'error': json['error'] == null ? undefined : json['error'],
        'errorCode': json['errorCode'] == null ? undefined : json['errorCode'],
        'meta': json['meta'] == null ? undefined : json['meta'],
        'traceId': json['traceId'] == null ? undefined : json['traceId'],
    };
}
function ReferralsControllerRedeemV1200ResponseToJSON(json) {
    return ReferralsControllerRedeemV1200ResponseToJSONTyped(json, false);
}
function ReferralsControllerRedeemV1200ResponseToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'statusCode': value['statusCode'],
        'status': value['status'],
        'message': value['message'],
        'data': (0, RedeemResultDto_1.RedeemResultDtoToJSON)(value['data']),
        'error': value['error'],
        'errorCode': value['errorCode'],
        'meta': value['meta'],
        'traceId': value['traceId'],
    };
}
